import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_WORKLOAD_NATIVE_VPA_SPEC_QUERY_KEY = 'woop-workload-native-vpa-spec';

const getWorkloadNativeVpaSpecQueryKey = ({
  clusterId,
  workloadId,
}: { clusterId?: string; workloadId?: string } = {}) =>
  [WOOP_WORKLOAD_NATIVE_VPA_SPEC_QUERY_KEY, clusterId, workloadId] as const;

export type UseWorkloadNativeVpaSpecQueryArgs = {
  clusterId?: string;
  workloadId?: string;
  enabled?: boolean;
};

const getWorkloadNativeVpaSpecQueryOptions = ({
  clusterId,
  workloadId,
  enabled,
}: UseWorkloadNativeVpaSpecQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadNativeVpaSpecQueryKey({ clusterId, workloadId }),
    queryFn: async () => {
      const { data } = await apiClient.workloadOptimization.getNativeVpaSpec({
        clusterId: clusterId!,
        workloadId: workloadId!,
      });
      return data;
    },
    enabled: makeIsEnabled(enabled, !!(clusterId && workloadId)),
  });

export const useWorkloadNativeVpaSpecQuery = (
  args: UseWorkloadNativeVpaSpecQueryArgs
) => {
  const { data, isLoading, error, refetch } = useQuery(
    getWorkloadNativeVpaSpecQueryOptions(args)
  );

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
